import React from 'react';

import { Link, Box } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';

const Linkable = (link) => link
  ? ({ children, ..._props }) => (
    <Link
      as={ReactRouterLink}
      to={link}
      _hover={{ boxShadow: 'outline' }}
      {..._props}
    >
      {children}
    </Link>
  ) : ({ children, ..._props }) => <Box {..._props}>{children}</Box>;

export default Linkable;
